<template>
<div class="comments-panel">
    <confirmModal v-if="showConfirmModal" message="Vous êtes sûr de vouloir supprimer ce commentaire ?" @confirm="confirmDeleteComment" @closeMessage="showConfirmModal = false"></confirmModal>
    <textEditModal v-if="showTextEditModal" ref="commentEditor" @confirm="confirmEditComment" :content="commentToEdit.comment" @closeMessage="showTextEditModal = false"></textEditModal>
    <div v-if="commentList">
        <div v-if="commentList.length === 0" class="comment-panel-title">
            <div class="row columns">
                <div class="small-12 columns">
                </div>
            </div>
        </div>
        <div v-else class="comments-panel-title">
            <div class="row columns">
                <div class="small-12 columns">
                    <p>{{commentList.length}} commentaires :</p>
                </div>
            </div>
        </div>
        <hr>
        <div class="comment-panel" v-for="comment in commentList">
            <div class="row columns">
                <div class="medium-2 small-4 columns">
                    <img :src="getUserAvatar(comment.user.id)" alt="autheur">
                </div>
                <div class="medium-10 small-8 columns">
                    <div class="row">
                        <div class="large-3 columns">
                            <p class="author-name">{{comment.user.username}}</p>
                            <span class="comment-date"><i class="fa fa-calendar" aria-hidden="true"></i>le {{comment.submit_date | formatDate }}</span>
                        </div>
                        <div class="large-3 large-offset-6 columns">
                            <div class="action-buttons">
                                <button v-if="currentUser != null && (comment.user.id === currentUser.id)"
                                    @click="startEditComment($event)"
                                    class="small"
                                    :id="comment.id">
                                    <i :id="comment.id" class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                                <button v-if="currentUser != null && (currentUser.is_superuser || comment.user.id === currentUser.id)"
                                    @click="startDeleteComment($event)"
                                    :id="comment.id"
                                    class="alert small">
                                    <i :id="comment.id" class="fa fa-trash-o" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div 
                            class="large-1 columns">
                        </div>
                    </div>
                    <div class="row columns">
                    </div>
                    <hr class="comment-separator">
                    <div class="row columns">
                        <p :id="comment.id" v-html="comment.comment"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="row">
        <spinner></spinner>
    </div>
    <div class="comment-form" id="commentForm" v-if="currentUser">
        <div class="row columns">
            <div class="large-10 columns large-centered">
                <div class="comments-form-title">
                    Publier un commentaire :
                </div>
                <div class="form-group">
                    <textEdit ref="commentCreator"></textEdit>
                </div>
                <br>
                <div class="row">
                    <div class="large-centered large-2">
                        <button @click="publishComment()" class="full-width">publier</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="comment-form" id="commentForm" v-else>
        connectez vous pour laisser un commentaire
    </div>
</div>
</template>

<script>
import store from '../../store/index.js'
import spinner from './spinner.vue'
import confirmModal from './confirm-modal.vue'
import textEditModal from './text-edit-modal.vue'
import formatDate from '../../common/filters.js'
import { mapGetters } from 'vuex'
import com from '../../api/comment.api'
import textEdit from './text-edit.vue'

export default {
  name: 'commentPanel',
  props: {
    'entity_type': null,
    'entity_id': null
  },
  components: {
    spinner,
    textEditModal,
    textEdit,
    confirmModal
  },
  data () {
    return {
      showConfirmModal: false,
      showTextEditModal: false,
      commentToEdit: null,
      commentToDelete: null
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'commentList'
    ]),
    entityDatas: function () {
      let entityDatas = []
      entityDatas[0] = this.entity_type
      entityDatas[1] = this.entity_id
      return entityDatas
    }
  },
  filters: {
    formatDate
  },
  created () {
    store.dispatch('getCommentList', this.entityDatas)
    store.dispatch('getAllUserAvatar')
  },
  methods: {
    getUserAvatar (userId) {
      let avatar = store.getters.getUserAvatar(userId)
      if (avatar !== null && avatar !== undefined) {
        return avatar.avatar
      }
      return 'http://lorempixel.com/640/480/'
    },
    startEditComment ($event) {
      this.commentToEdit = this.commentList.find(com => com.id === parseInt(event.target.id, 10))
      this.showTextEditModal = true
    },
    confirmEditComment () {
      this.showTextEditModal = false
      let comment = this.commentToEdit
      comment.comment = this.$refs.commentEditor.getText()
      comment.submit_date = new Date()
      comment.user = this.currentUser.id
      com.api.updateComment(comment)
      .then(response => {
        store.dispatch('getCommentList', this.entityDatas)
      },
      error => {
        console.log('impossible to update comment')
        console.log(error)
      })
    },
    startDeleteComment ($event) {
      console.log($event)
      this.commentToDelete = this.commentList.find(com => com.id === parseInt(event.target.id, 10))
      this.showConfirmModal = true
    },
    confirmDeleteComment () {
      this.showConfirmModal = false
      com.api.deleteComment(this.commentToDelete)
      .then(
      response => {
        store.dispatch('getCommentList', this.entityDatas)
      },
      error => {
        console.log('impossible to delete comment')
        console.log(error)
      })
    },
    publishComment () {
      let comment = {}
      comment.comment = this.$refs.commentCreator.getText()
      comment.object_pk = this.entity_id
      comment.submit_date = new Date()
      comment.user = this.currentUser.id
      comment.site = 1
      comment.content_type = this.entity_type
      console.log(comment)
      var that = this
      com.api.createComment(comment)
      .then(response => {
        store.dispatch('getCommentList', this.entityDatas)
        that.$refs.commentCreator.setText('')
        that.showModal = true
      },
      error => {
        console.log('impossible to create comment')
        console.log(error)
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.comment-separator {
    margin-top: 0.5rem;
}

.comment-content {
    font-size:1rem;
}

.comments-panel-title {
    text-align: left;
    font-weight: 300;
    font-size: 1.8rem;
    padding-top: 1.3rem;

}

.comment-panel {
    padding: 0.5rem;
    background-color: #fafafa;
    margin-bottom:0.5rem;
    text-align:left;
}

.comment-date {
    font-size: 0.7rem;
    font-weight: 300;
}

p.author-name{
    font-size: 1.1rem;
    margin:0;
}

.action-buttons {
    float: right;
}

.comment-form {
    background-color: #fafafa;
    padding: 1.3rem;
}

.comments-form-title {
    text-align: left;
    font-weight: 300;
    font-size: 1.5rem;
    padding-bottom: 1.3rem;
}
</style>



// WEBPACK FOOTER //
// comment-panel.vue?3a780862